import * as CodeDaleTheme from "@CodeDaleTheme/global";
import { eventModal } from "@CodeDaleTheme/modal";

// Delay before opening the freshly injected modal, giving the DOM time to attach it.
const MODAL_OPEN_DELAY_MS = 100;

/**
 * <popup-password> — trigger element that injects and opens the storefront
 * password modal (<password-modal-popup>) on click or keyboard activation.
 */
class PopupPassword extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", this.onClick.bind(this), false);
    this.addEventListener("keydown", this.onKeyDown.bind(this), false);
  }

  onKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.onClick(event);
    }
  }

  onClick(event) {
    this.mountModal(event);

    setTimeout(() => {
      eventModal(document.querySelector("password-modal-popup"), "open", true);
    }, MODAL_OPEN_DELAY_MS);

    CodeDaleTheme.global.rootToFocus = this;
  }

  // Clone the modal markup from the inline <template> and append it to <body>.
  mountModal(event) {
    const modalTemplate = event.target
      .closest("popup-password")
      .querySelector("template");

    if (!modalTemplate) return;

    const wrapper = document.createElement("div");
    wrapper.appendChild(modalTemplate.content.firstElementChild.cloneNode(true));
    CodeDaleTheme.getBody().appendChild(
      wrapper.querySelector("password-modal-popup")
    );
  }
}

customElements.define("popup-password", PopupPassword);
